import type { Jet } from '~/jet';
import type { LoggerFactory } from '@amp/web-apps-logger';
// Safe because this file is only imported from ./browser.ts
import type { Playback } from '~/utils/playback/browser-only';
import type { RemoveQueueItemAction } from '~/actions/playback-actions';

export type Dependencies = {
    jet: Jet;
    logger: LoggerFactory;
    playback: Playback;
};

export function registerHandler(dependencies: Dependencies) {
    const { jet, logger, playback } = dependencies;

    const log = logger.loggerFor(
        'jet/action-handlers/remove-queue-item-action',
    );

    jet.onAction(
        'removeQueueItemAction',
        async (action: RemoveQueueItemAction) => {
            log.info('received RemoveQueueItemAction:', action);
            try {
                if (action.itemIndex !== undefined) {
                    await playback.removeQueueItem(
                        action.itemId,
                        action.itemIndex,
                    );
                } else {
                    await playback.findAndRemoveQueueItems([action.itemId]);
                }
                return 'performed';
            } catch (e) {
                log.error('Remove Item From Queue Action Error:', e);
                throw new Error(
                    'an error occurred while removing an item from the queue',
                );
            }
        },
    );
}
